<template>
    <div style="width: 100vw; height: 100vh; position: absolute; left: 0px; top: 0px; background: rgba(0, 0, 0, 0.8); backdrop-filter: blur(10px)">
        <div style="display: flex; flex-direction: column; align-items: center; padding: 0px 0px 24px; gap: 16px; position: absolute; left: calc(50% - 100vw / 2); top: calc(50% - 50vh / 2 + 0.5px); background: #ffffff; border-radius: 12px; margin: 0 16px">
            <div class="fs-24 fw-600 color-white" style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 12px 0px; gap: 10px; width: 100%; height: 62px; background: #cc0000; flex: none; order: 0; flex-grow: 0; border-top-left-radius: 12px; border-top-right-radius: 12px">ใช้คูปอง</div>
            <span class="fs-18 fw-600 red text-center" style="padding: 0 16px"> {{ reward.title }} </span>
            <span class="fs-18" v-html="reward.plivilege"> </span>
            <span class="fs-18">รหัสคูปองมีอายุ {{ Number(reward.count_time / 60) }} นาที</span>
            <div class="text-center">
                <a-button class="cancel-btn ant-button-label-custom custom-btn fs-18" @click="$router.replace({ path: '/reward' })">
                    <strong>ยกเลิก</strong>
                </a-button>
                <a-button class="primary-btn ant-button-label-custom custom-btn ml-16 fs-18" @click="$router.replace({ path: '/reward-code', query: { reward } })">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            reward: this.$route.query.reward,
        };
    },
    methods: {},
};
</script>
<style scoped>
.detail {
    font-weight: 300;
    margin: 0;
    color: #000 !important;
}
.custom-btn {
    border: 0;
    border-radius: 0;
    height: 32px;
    line-height: 32px;
}
</style>